if (window.innerWidth > 1024) {
    document.querySelectorAll('details').forEach(function(details) {
        details.setAttribute('open', ''); // Keeps it open
        details.addEventListener('click', function() {
            details.setAttribute('open', ''); // Keeps it open on click
        });
    });
}